import { render, staticRenderFns } from "./PageAdminSyncProfiles.vue?vue&type=template&id=75c79058"
import script from "./PageAdminSyncProfiles.vue?vue&type=script&lang=js"
export * from "./PageAdminSyncProfiles.vue?vue&type=script&lang=js"
import style0 from "./PageAdminSyncProfiles.vue?vue&type=style&index=0&id=75c79058&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports